<script lang="ts">
  import type { ITab } from '../../etc/types';

  export let tabs: ITab[];
  export let onChange: (value: any) => void;

  let selected = 0;

  const changeTab = (tab: ITab, index: number) => {
    selected = index;
    onChange(tab.value);
  };
</script>

<div class="tab-container">
  {#each tabs as tab, i}
    <div
      class="tab"
      on:click={() => changeTab(tab, i)}
      class:active={selected === i}
    >
      <h3>{tab.label}</h3>
    </div>
  {/each}
</div>

<style lang="scss">
  .tab-container {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
  }

  .tab {
    cursor: pointer;
    border-bottom: 1.2px solid #bac9d8;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding: 14px 0;

    h3 {
      font-size: 14px;
      line-height: 18px;
      color: $color-neutral-gray;
      transition: color 0.2s;
      padding: 0 2px;
      font-weight: normal;
      margin: 0;
    }

    &.active {
      border-bottom: 1.2px solid var(--twism-theme-primary);
      border-radius: 1px;

      h3 {
        font-weight: bold;
        color: var(--twism-theme-text);
      }
    }
  }
</style>
